import * as layerSettings from "@/settings/wms.settings"

const state = {
    layerSettings: layerSettings.default,
    layerLoading: false
};

const getters = {
    wmsLayerCategories: (state) => {
        const layerCategoryList = [];

        Object.entries(state.layerSettings).forEach(service => {
            service[1].layer.forEach(layer => {
                layerCategoryList.push(layer.category)
            })
        });
        let categories = new Set(layerCategoryList);
        return [...categories].sort()
    }
};

const actions = {
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}